<template lang="html">
<div class="lg:block dark:bg-gray-800 bg-white fixed left-0 right-0 bottom-0 mb-5 ml-5 md:ml-0 mr-5 p-4 md:w-96 rounded-md shadow-lg" style="z-index: 150" v-show="showRating">
  <div v-show="showForm">
    <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
      <!-- Megaphone icon -->
      <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
          d="M17.223 7.03c-1.584-3.686-4.132-6.49-5.421-5.967-2.189.891 1.304 5.164-9.447 9.533-.929.379-1.164 1.888-.775 2.792.388.902 1.658 1.801 2.587 1.424.161-.066.751-.256.751-.256.663.891 1.357.363 1.604.928l1.158 2.66c.219.502.715.967 1.075.83l2.05-.779c.468-.178.579-.596.436-.924-.154-.355-.786-.459-.967-.873-.18-.412-.769-1.738-.938-2.156-.23-.568.259-1.031.97-1.104 4.894-.512 5.809 2.512 7.475 1.834 1.287-.525 1.025-4.259-.558-7.942zm-.551 5.976c-.287.115-2.213-1.402-3.443-4.267-1.231-2.863-1.076-5.48-.79-5.597.286-.115 2.165 1.717 3.395 4.58 1.231 2.863 1.124 5.167.838 5.284z"/>
      </svg>
    </div>
    <div class="text-lg font-medium mt-4">
      Please tell us about your experience with MicTap
    </div>
    <label for="rating" class="mt-4 font-medium">What would you rate the audio/video quality</label>
    <div class="flex space-x-3">

      <!-- Star icon  -->
      <svg v-for="s in this.rateValues" :class="{'text-yellow-500': s <= rating, 'text-gray-500': s > rating}" @click="rating = s" class="w-12 h-12 " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path d="M10 1.3l2.388 6.722H18.8l-5.232 3.948 1.871 6.928L10 14.744l-5.438 4.154 1.87-6.928-5.233-3.948h6.412L10 1.3z"/></svg>
    </div>
      <label for="comments" class="mt-2 font-medium">Comments (optional)</label>
      <textarea class="form-input h-24" v-model="comments" rows="3"></textarea>
      <div class="flex space-x-2 mt-5">
        <button class="btn btn-secondary" @click="sendRating()">Send</button>
        <button class="underline text-gray-700 dark:text-gray-300" @click="showRating = false"> Maybe later</button>
      </div>
    </div>
    <div v-show="showThankYou">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Check icon -->
        <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path
              d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.392 1.392 0 0 1 .27-1.951 1.392 1.392 0 0 1 1.953.27l2.351 3.104 5.911-9.492a1.396 1.396 0 0 1 1.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 0 1-1.12.656c-.022.002-.042.002-.064.002z"/>
        </svg>
      </div>
      <div class="text-lg mt-4 font-medium text-center">
        Thank you for your feedback!
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ['participant_id'],
  data() {
    return {
      //appearInSeconds: 15 * 60, // appear after 15 minutes
      showRating: false,
      showForm: false,
      showThankYou: false,
      rating: 0,
      comments: '',
      rateValues: [1, 2, 3, 4, 5]
    }
  },
  mounted() {
    this.$root.$on('session-end', () => {
      this.showRating = true;
      this.showForm = true;
    })
    this.rating = parseInt(Math.random() * 4) + 1; // randomising default rating to not aschew data.
  },
  methods: {
    sendRating() {
      // send ajax to server
      axios.post('/participants/' + this.participant_id + '/rate_session',{
        authenticity_token: authenticity_token,
        rating: this.rating,
        comments: this.comments
      }).then(response => {
        this.showForm = false;
        this.showThankYou = true;
        window.setTimeout(() => {
          this.showRating = false;
        }, 2000)
      }).error(error => {

      })


    }
  },
}
</script>
<style lang="">

</style>
